import { qualityApiClient } from '@/shared/api/core/axios-instance';

export type QualityTrendApiResponse = {
  statDate: string;
  dataZone: string;
  totalRows: number;
  goodRows: number;
  poorRows: number;
  unknownRows: number;
  goodRatio: number;
};

export type QualityTrendApiParams = {
  fromDate: string;
  toDate: string;
  dataZone?: string;
};

export type QualityTrendApiResult = {
  success: boolean;
  data: QualityTrendApiResponse[];
  meta: {
    fromDate: string;
    toDate: string;
    days: number;
    dataZone: string;
  };
};

export const getQualityTrend = async (params: QualityTrendApiParams): Promise<QualityTrendApiResult> => {
  try {
    const { data } = await qualityApiClient.get<QualityTrendApiResult>('/stats/quality-trend', { params });
    return data;
  } catch (error) {
    console.error('Failed to fetch quality trend:', error);
    throw error;
  }
};
